import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  labelClassName?: string;
  error?: string;
  helpText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, labelClassName, error, helpText, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className={labelClassName || "mb-1 block text-sm font-medium text-content-secondary"}>
            {label}
            {props.required && <span className="text-red-500">*</span>}
          </label>
        )}
        <input
          ref={ref}
          className={`w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-surface-raised text-content-primary px-3 py-2 transition-colors focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20 disabled:bg-surface-sunken disabled:text-content-secondary disabled:cursor-not-allowed placeholder-gray-400 dark:placeholder-gray-500 dark:[color-scheme:dark] ${
            error ? 'border-red-500 dark:border-red-400' : ''
          } ${className}`}
          {...props}
        />
        {helpText && !error && <p className="mt-1 text-xs text-content-secondary">{helpText}</p>}
        {error && <p className="mt-1 text-sm text-red-600 dark:text-red-400">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
